import React from 'react'

function AISolutions() {
  return (
    <div id="AI-Solutions" className="basic-2">
        <div className="container">
            <div className="row">
                <div className="col-lg-12">
                    <div className="section-title">
                        <h2>Our AI Solutions</h2>
                        <p className="p-heading">Transform your business with our comprehensive suite of AI-powered solutions designed for measurable productivity gains and competitive advantage.</p>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-lg-6 col-xl-6">
                    <div className="text-container">
                        <div className="above-heading blue">AI-POWERED INTELLIGENCE</div>
                        <h3>Business Intelligence & Analytics</h3>
                        <p>Our advanced AI models process vast amounts of business data to deliver actionable insights that drive strategic decision-making. Using the latest in large language model technology and enhanced reasoning capabilities, our solutions help you understand market trends, customer behavior, and operational efficiency like never before.</p>
                        <ul className="list-unstyled li-space-lg">
                            <li className="media">
                                <i className="fas fa-check"></i>
                                <div className="media-body">Advanced analytics with context windows processing millions of data points</div>
                            </li>
                            <li className="media">
                                <i className="fas fa-check"></i>
                                <div className="media-body">Real-time business intelligence dashboards</div>
                            </li>
                            <li className="media">
                                <i className="fas fa-check"></i>
                                <div className="media-body">Predictive modeling for market trends and customer behavior</div>
                            </li>
                        </ul>
                        <a className="btn-solid-reg" href="#contact">Learn More</a>
                    </div>
                </div>
                <div className="col-lg-6 col-xl-6">
                    <div className="text-container">
                        <div className="above-heading blue">AUTONOMOUS AGENTS</div>
                        <h3>AI Agents That Never Sleep</h3>
                        <p>Our autonomous AI agents represent the cutting edge of agentic AI technology, capable of performing complex business tasks with minimal human oversight. These digital workers integrate seamlessly into your existing workflows, handling everything from customer service inquiries to data analysis and report generation.</p>
                        <ul className="list-unstyled li-space-lg">
                            <li className="media">
                                <i className="fas fa-check"></i>
                                <div className="media-body">Multi-agent orchestration for complex business processes</div>
                            </li>
                            <li className="media">
                                <i className="fas fa-check"></i>
                                <div className="media-body">Agent-to-Agent (A2A) communication for collaborative tasks</div>
                            </li>
                            <li className="media">
                                <i className="fas fa-check"></i>
                                <div className="media-body">60% reduction in manual processing time</div>
                            </li>
                        </ul>
                        <a className="btn-solid-reg" href="#contact">Get Started</a>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-lg-6 col-xl-6">
                    <div className="text-container">
                        <div className="above-heading blue">MODEL CONTEXT PROTOCOL</div>
                        <h3>Unified Data Ecosystem</h3>
                        <p>As pioneers in Model Context Protocol implementation, we provide seamless integration between your AI systems and existing data sources. Our MCP solutions eliminate data silos and create a unified intelligence layer that connects everything from content repositories to business applications.</p>
                        <ul className="list-unstyled li-space-lg">
                            <li className="media">
                                <i className="fas fa-check"></i>
                                <div className="media-body">Pre-built connectors for Google Drive, Slack, GitHub, and more</div>
                            </li>
                            <li className="media">
                                <i className="fas fa-check"></i>
                                <div className="media-body">70% reduction in data integration time</div>
                            </li>
                            <li className="media">
                                <i className="fas fa-check"></i>
                                <div className="media-body">45% improvement in AI response accuracy</div>
                            </li>
                        </ul>
                        <a className="btn-solid-reg" href="#contact">Explore MCP</a>
                    </div>
                </div>
                <div className="col-lg-6 col-xl-6">
                    <div className="text-container">
                        <div className="above-heading blue">BLOCKCHAIN SECURITY</div>
                        <h3>Transparent & Secure Operations</h3>
                        <p>Our blockchain solutions provide the security and transparency modern businesses demand. From supply chain tracking to secure document management, our blockchain implementations ensure data integrity while reducing operational costs and compliance overhead.</p>
                        <ul className="list-unstyled li-space-lg">
                            <li className="media">
                                <i className="fas fa-check"></i>
                                <div className="media-body">Smart contract automation for business processes</div>
                            </li>
                            <li className="media">
                                <i className="fas fa-check"></i>
                                <div className="media-body">Immutable audit trails for compliance</div>
                            </li>
                            <li className="media">
                                <i className="fas fa-check"></i>
                                <div className="media-body">30% reduction in compliance costs</div>
                            </li>
                        </ul>
                        <a className="btn-solid-reg" href="#contact">Secure Your Business</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default AISolutions

